// Generated by CoffeeScript 1.9.0
var Fasta, GenericReader;
GenericReader = require("biojs-io-parser");
Fasta = require("./fasta");
module.exports = Fasta;
GenericReader.mixin(Fasta);